module.exports = __webpack_public_path__ + "/images/cover-header-vendedores.ff2d02e.png";